// $(window).on('load',function(){
 //  jQuery('body').css('overflow-y','visible');
	// setTimeout(function(){ // allowing 3 secs to fade out loader
	// $('.page-loader').fadeOut('slow');
	// },3500);
// });
// $('video img').attr('loading', 'lazy');
jQuery( document ).ready(function() {  
    jQuery('body').css('overflow-y','visible');
	setTimeout(function(){ // allowing 3 secs to fade out loader
    	$('.page-loader').fadeOut('slow');
	},2000);  
    $(".VideoContainer").click(function() {
    var video = $(this).find("video").get(0);
    var playButton = $(this).find(".play");
    if (video.paused) {
      video.play();
      playButton.fadeOut(500);
    } else {
      video.pause();
      playButton.fadeIn(500);
    }
    $(video).on('ended', function() {
      video.load();
      playButton.fadeIn(500);
    });
  });
});
jQuery( document ).ready(function() {
   setTimeout(function () {
      $('.jdgm-rev-widg__summary-inner .jdgm-star').wrapAll('<div class="customRevStar"></div>');
      var element = $(".jdgm-rev-widg__summary-average");
      // Get the current content
      var text = element.text();    
      // Convert the text to a floating-point number and format it to have two decimal places
      var formattedNumber = parseFloat(text).toFixed(2);
      // Set the new formatted content to the element
      element.text(formattedNumber);
    //  $('.jdgm-rev__author').text("Matt Cooper");
     $("#judgeme_product_reviews").css("display", "block")    
  }, 3000)
});
